import React from "react";
import "styles/banner-text.css";

const BannerText = ({ children, Image }) => {
  return (
    <div className="container-text">
      {children}
      <img src={Image} alt="Grupo Alianza Colombia" className="image" />
    </div>
  );
};

export default BannerText;
